export default __webpack_public_path__ + "static/media/sunjukta.64fd7f59.png";